import React from 'react'

const userReducer = (state, { type, payload }) => {
  switch (type) {
    case 'LOGIN':
      return {
        ...state,
        user: { ...state.user, ...payload.user },
        token: payload.token,
      }
    case 'LOGOUT':
      return {
        user: null,
        token: null,
      }
    case 'GET_USER':
      return {
        ...state,
        user: { ...state.user, ...payload.user },
        token: state.token || payload.token,
      }
    case 'GET_USER_POST':
      return {
        ...state,
        user: { ...state.user, ...payload.user },
      }
    default:
      throw new Error(`Unhandled action type: ${type}`)
  }
}

export { userReducer }
